<template>
  <div class="addOnlineContainer">
    <section>
      <h2>1、批量出库(下载示例)</h2>
      <ul>
        <li>
          <label>项目：</label>
          <a-select
            style="width:300px"
            showSearch
            @change="selectGoods"
            v-model="project_id"
            :filterOption="filterOption"
            optionFilterProp="children"
            placeholder="请选择项目"
          >
            <a-select-option
              v-for="(item, i) in proList"
              :key="i"
              :value="item.id"
              >{{ item.project_name }}</a-select-option
            >
          </a-select>
        </li>
        <li>
          <label>机器类型：</label>
          <a-radio-group v-model="version">
            <a-radio :value="1">
              一代机
            </a-radio>
            <a-radio :value="2">
              二代机
            </a-radio>
            <a-radio :value="3">
              三代机
            </a-radio>
          </a-radio-group>
        </li>
        <li>
          <label>热销类型：</label>
          <a-radio-group v-model="sale_type">
            <a-radio :value="2">
              热销
            </a-radio>
            <a-radio :value="1">
              非热销
            </a-radio>
          </a-radio-group>
        </li>
        <li v-show="showIsGoods">
          <label><i>*</i>商品名称：</label>
          <a-select
            showSearch
            mode="multiple"
            style="width:300px"
            :filterOption="filterOption"
            v-model="goodsVal"
            optionFilterProp="children"
          >
            <a-select-option
              v-for="(item, i) in goodsList"
              :key="i"
              :value="item.project_material_id"
              >{{ item.brand_name }}</a-select-option
            >
          </a-select>
        </li>
        <li class="goodsStyle" v-for="(element, k) in goodsSelect" :key="k">
          <label><i>*</i>{{ element.name + "：" }}</label>
          <a-input style="width:150px" v-model="element.num"></a-input>
        </li>
      </ul>
      <a-button type="primary" @click="downLoadPage">{{
        downloadTxt
      }}</a-button>
    </section>
    <section>
      <h2>2、批量出库【 上传出库 】</h2>
      <ul>
        <li>
          <label><i>*</i>出库日期：</label>
          <a-date-picker v-model="out_date" />
        </li>
        <li>
          <label><i>*</i>表格：</label>
          <input type="file" @change="changeExcelVal" />
        </li>
      </ul>
      <a-button type="primary" @click="submitUpload">{{
        upTxtAdvance
      }}</a-button>
    </section>
    <div class="hint">
      <h3>注意事项</h3>
      <span>1、必须为.xls或.xlsx结尾的excel；</span>
      <span>2、表格中不得有空行空列，无数据填0；</span>
      <span>3、表格中所有数据均为文本格式；</span>
      <span>4、表格日期指甲方给表日期,首次上传新增，重复上传更新。</span>
    </div>
  </div>
</template>
<script>
import axios from "axios";
import moment from "moment";
export default {
  data() {
    return {
      moment,
      excelFile: "",
      downloadTxt: "下载",
      upTxt: "上传",
      advanceCashierFile: "",
      upTxtAdvance: "上传",
      batchAdvanceFile: "",
      upTxtBatchAdvance: "上传",
      salary_date: "",
      proList: [],
      goodsList: [],
      showIsGoods: false,
      goodsVal: [],
      goodsSelect: [],
      version: "",
      sale_type: "",
      project_id: "",
      out_date: ""
    };
  },
  mounted() {
    this.getPro();
  },
  watch: {
    goodsVal(val) {
      this.goodsSelect = [];
      this.goodsList.forEach(element => {
        if (val.indexOf(element.project_material_id) != -1) {
          this.goodsSelect.push({
            id: element.project_material_id,
            name: element.brand_name
          });
        }
      });
    }
  },
  methods: {
    downLoadPage() {
      let goods_var = [];
      this.goodsSelect.forEach(element => {
        goods_var.push({
          project_material_id: element.id,
          number: Number(element.num)
        });
      });
      // console.log(goodsVar)
      if (this.project_id != "" && goods_var != "") {
        this.downloadTxt = "下载中...";
        window.location.href =
          this.httpsBasic.url +
          this.httpsBasic.equipment +
          "Project_material/downloadProjectOutManyTpl?goods_var=" +
          JSON.stringify(goods_var) +
          "&project_id=" +
          this.project_id +
          "&version=" +
          this.version +
          "&sale_type=" +
          this.sale_type +
          "&token=" +
          window.localStorage.getItem("xnwfPcToken");
        this.downloadTxt = "下载";
      } else {
        this.$message.info("请选择项目并填写商品变量");
      }
    },
    selectGoods(id) {
      this.showIsGoods = true;
      let url =
        this.httpsBasic.url +
        this.httpsBasic.equipment +
        "Project_material/getListData";
      let params = {
        token: window.localStorage.getItem("xnwfPcToken"),
        project_id: id
      };
      axios.post(url, params).then(res => {
        if (res.data.code == 200) {
          this.goodsList = res.data.data;
          console.log(this.goodsList);
        }
      });
    },
    getPro() {
      let url =
        this.httpsBasic.url + this.httpsBasic.trade + "Project/projectList";
      axios
        .post(url, {
          current_page: 1,
          per_page: 10000,
          token: window.localStorage.getItem("xnwfPcToken"),
          trade_id: 2
        })
        .then(res => {
          if (res.data.code == 200) {
            this.proList = res.data.data.data;
          } else {
            this.$message.warning(res.data.message);
          }
        })
        .catch(err => {
          this.$message.error("服务器出错啦...");
          this.loading = false;
        });
    },
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text
          .toLowerCase()
          .indexOf(input.toLowerCase()) >= 0
      );
    },
    changeExcelVal(e) {
      this.excelFile = e.target.files[0];
    },
    submitUpload() {
      let _this = this;
      if (this.excelFile != "" && this.out_date != "") {
        this.$confirm({
          title: "是否确认该日期表格无问题上传",
          okText: "确认",
          okType: "danger",
          cancelText: "取消",
          onOk() {
            _this.upExcel();
          },
          onCancel() {
            // console.log("Cancel");
          }
        });
      } else {
        this.$message.warning("请选择规定格式的Excel上传");
      }
    },
    upExcel() {
      this.upTxt = "上传中...";
      let formData = new FormData();
      formData.append("excel", this.excelFile);
      formData.append("out_date", moment(this.out_date).format("YYYY-MM-DD"));
      formData.append("token", window.localStorage.getItem("xnwfPcToken"));
      let config = {
        headers: {
          "Content-Type": "multipart/form-data"
        }
      };
      let url =
        this.httpsBasic.url +
        this.httpsBasic.equipment +
        "Project_material/uploadProjectOutMany";
      axios
        .post(url, formData, config)
        .then(res => {
          if (res.data.code == 200) {
            this.$message.success("上传成功");
            this.excel = "";
            this.$emit("hideInExcelOut", false);
          } else {
            this.$message.warning(res.data.message);
          }
          this.upTxt = "上传";
        })
        .catch(err => {
          this.$message.error(err);
        });
      this.upTxt = "上传";
    }
  }
};
</script>
<style lang="less" scoped>
.addOnlineContainer {
  padding: 50px 4%;
  position: relative;
  ul {
    margin-top: 30px;
    li {
      margin-bottom: 20px;
    }
  }
  i {
    display: inline-block;
    color: red;
    font-style: normal;
    margin-right: 4px;
  }
  h2 {
    font-weight: normal;
    a {
      font-size: 14px;
      display: inline-block;
      margin-left: 20px;
    }

    > span {
      font-size: 14px;
    }
  }
  button {
    display: block;
    margin: 0 30px 50px 70px;
  }
  .hint {
    background: rgba(230, 162, 60, 0.1);
    padding: 10px 20px;
    margin: 10px 30px 20px;
    width: 400px;
    position: absolute;
    right: 0;
    top: 10px;
    z-index: 1;
    h3 {
      color: #666;
      font-size: 16px;
      font-weight: normal;
    }
    span {
      display: block;
      font-size: 14px;
      line-height: 24px;
      color: #666;
    }
  }
}
</style>
